import type {
  FormattedResolutionDetails,
  ResolutionSteps
} from '@library/types/resolutions/resolutionDetails';
import type { FormattedResolution } from '@library/types/resolutions/resolutionsList';
import { resolutionSteps } from '@bo-constants/resolutions/resolutionDetailsStepper';

export const initialNewResolution: FormattedResolution = {
  adminName: '',
  adminEmail: '',
  createdAtDate: '',
  createdAtTime: '',
  id: 'NEW',
  reason: '',
  status: 'draft',
  type: '',
  updatedAtDate: '',
  updatedAtTime: ''
};

export const defaultFormattedResolutionDetails: FormattedResolutionDetails = {
  actualAffectedWagers: 0,
  actualRefundCents: 0,
  csvRowCount: 0,
  cvsFileName: 'cvsFile.cvs',
  estimatedAffectedWagers: 0,
  estimatedRefundCents: 0,
  numberOfIdsProcessed: 0,
  processingStartedAt: '',
  resolutionId: '',
  status: 'preprocessing'
};

export const defaultResolutionStepsWithStatus: ResolutionSteps =
  resolutionSteps.map((step) => ({ ...step, status: 'pending' }));
